import Link from "~/bridge/ui/Link";
import { useAppContext } from "../../app-context/provider";
import { Topic } from "../../../use-cases/contracts/Topic";

export const TopicLabels: React.FC<{ topics: Topic[] }> = ({ topics }) => {
  const { path } = useAppContext();
  return (
    <div className="topic-labels flex flex-wrap gap-2">
      {topics.map((topic) => (
        // Topic names are not unique - two topics in different branches of
        // the tree can share a label - so key on the path, which is identity.
        <Link to={path(topic.path)} key={topic.path}>
          <div className="rounded-md bg-[#efefef] border border-transparent hover:border-black px-3 py-1">
            <p className="text-xs font-bold">{topic.name}</p>
          </div>
        </Link>
      ))}
    </div>
  );
};
